import styled from 'styled-components';

import { Div, FlexCol } from 'common/styles/oc-styled-components';

import { colors } from '../../../../common/styles/style-constants';

export const FlexColCentered = styled(FlexCol)`
  bottom: 45px;
  position: relative;
  text-align: center;
`;

export const AddressLine = styled(Div)`
  color: ${colors.charcoal};
  font-size: 15px;
`;
